
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".499","y":".5","width":"29","height":"29","rx":"4.5","stroke":"#737882"}}),_c('path',{attrs:{"d":"M24.867 14.627c-1.818-2.215-5.667-4.8-9.867-4.8-4.215 0-8.064 2.603-9.867 4.8a.588.588 0 000 .746c1.861 2.268 5.719 4.8 9.867 4.8 4.296 0 8.128-2.681 9.867-4.8a.588.588 0 000-.746zM18.996 15A4 4 0 0115 18.996 4 4 0 0111.004 15 4 4 0 0115 11.004 4 4 0 0118.996 15zM6.383 15c.662-.688 2.258-2.173 4.5-3.126a5.16 5.16 0 00-.001 6.251c-1.704-.722-3.287-1.863-4.5-3.125zm12.735 3.126a5.159 5.159 0 000-6.251c1.704.722 3.287 1.863 4.5 3.125-.663.688-2.26 2.173-4.5 3.126z","fill":"#9B9B9B"}}),_c('path',{attrs:{"d":"M13 15c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2zm2.824 0a.825.825 0 01-1.647 0 .824.824 0 011.647 0zM15 7.55a.588.588 0 00.588-.59V5.589a.588.588 0 10-1.176 0v1.373c0 .325.263.588.588.588zM18.51 8.336c.282.16.641.063.802-.22l.783-1.372a.588.588 0 00-1.022-.583l-.783 1.372a.588.588 0 00.22.803zM10.688 8.116a.588.588 0 001.022-.583l-.783-1.372a.588.588 0 10-1.022.583l.783 1.372zM15 22.451a.588.588 0 00-.588.588v1.373a.588.588 0 101.176 0v-1.373a.588.588 0 00-.588-.588zM11.49 21.664a.588.588 0 00-.802.22l-.783 1.372a.588.588 0 001.022.583l.783-1.372a.588.588 0 00-.22-.803zM19.312 21.884a.588.588 0 10-1.022.583l.783 1.372a.588.588 0 001.022-.583l-.783-1.372z","fill":"#9B9B9B"}})])
          )
        }
      }
    